// @ts-strict
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { LMRouteComponentService } from '@services/index';
import { FieldOperatorChangedEvent, LMFieldPickerView, LMOperatorInfo } from "@modal/field-picker/lm-field-picker";
import { LMFieldPickerService } from "@app/components";
import { LMGlobalPersonalizationService } from "@app/states";


@Component({
  selector: 'lm-field-picker-operator',
  standalone: false,
  templateUrl: './lm-field-picker-operator.component.html',
  styleUrls: [ './lm-field-picker.component.scss' ],
  providers: [ LMRouteComponentService ]
  })
export class LMFieldPickerOperatorComponent implements OnInit {

  @Input() uiFieldSpec!: UIFieldSpec;
  @Input() operatorInfo!: LMOperatorInfo;
  @Input() view!: LMFieldPickerView;
  @Input() auditData!: boolean;
  @Input() validPeriods!: Array<string>;

  useCompactFormLayout = false;
  lplName: string | undefined;
  operatorExample: string | undefined;

  constructor(
    private lmFieldPickerService: LMFieldPickerService,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService,
  ) {
    // @ts-ignore
    this.useCompactFormLayout = this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout ? this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout : false;
  }
  ngOnInit() {
    if (!this.operatorInfo) {
      this.operatorInfo = this.lmFieldPickerService.blankOperatorInfo();
    }
    this.update();
  }
  onOperatorChange(event: FieldOperatorChangedEvent) {
   this.update();
  }
  private update() {
    this.lplName = this.lmFieldPickerService.buildFieldNameWithOperatorInfo(this.uiFieldSpec, this.operatorInfo, this.view);
    this.operatorExample = this.lmFieldPickerService.buildFormatExample(this.operatorInfo);
  }
}

